import { IMetaTag } from '@/models/metaTags.model';
import { MetaTagsFormFieldsNames, TMetaTagsFormValues } from '../helpers/types';
import { SupportedLocales } from '@/models/localization.model';

export const mapInitialFormValues = (metaTag?: IMetaTag | null): TMetaTagsFormValues => {
  if (!metaTag) {
    return {
      [MetaTagsFormFieldsNames.SLUG]: '',
      [MetaTagsFormFieldsNames.INDEX]: true,
      [MetaTagsFormFieldsNames.LOCALE]: {
        [SupportedLocales.RU]: {
          [MetaTagsFormFieldsNames.TITLE]: '',
          [MetaTagsFormFieldsNames.DESCRIPTION]: '',
          [MetaTagsFormFieldsNames.KEYWORDS]: [],
          [MetaTagsFormFieldsNames.TEXT]: '',
        },
        [SupportedLocales.UK]: {
          [MetaTagsFormFieldsNames.TITLE]: '',
          [MetaTagsFormFieldsNames.DESCRIPTION]: '',
          [MetaTagsFormFieldsNames.KEYWORDS]: [],
          [MetaTagsFormFieldsNames.TEXT]: '',
        },
      },
    };
  }
  const locales = metaTag?.locale?.reduce(
    (acc, item) => {
      acc[item.locale] = {
        [MetaTagsFormFieldsNames.TITLE]: item.title ?? '',
        [MetaTagsFormFieldsNames.DESCRIPTION]: item.description ?? '',
        [MetaTagsFormFieldsNames.KEYWORDS]: item.keywords ?? [],
        [MetaTagsFormFieldsNames.TEXT]: item.text ?? '',
      };
      return acc;
    },
    {} as Record<
      SupportedLocales,
      {
        [MetaTagsFormFieldsNames.TITLE]?: string;
        [MetaTagsFormFieldsNames.DESCRIPTION]?: string;
        [MetaTagsFormFieldsNames.KEYWORDS]?: string[];
        [MetaTagsFormFieldsNames.TEXT]?: string;
      }
    >,
  );

  return {
    [MetaTagsFormFieldsNames.SLUG]: metaTag?.slug ?? '',
    [MetaTagsFormFieldsNames.INDEX]: metaTag?.index,
    [MetaTagsFormFieldsNames.LOCALE]: locales,
  };
};
